import React from 'react';
import { FormattedMessage } from 'react-intl';
import Spinner from './spinner';

export default function withLoading(
  WrappedComponent,
  title = <FormattedMessage id='messages.FETCHING' />,
  translate = false,
) {
  return (props) => {
    // eslint-disable-next-line
    if (props.isLoading) {
      return <Spinner title={translate ? <FormattedMessage id={title} /> : title} />;
    }

    return <WrappedComponent {...props} />;
  };
}

